import React from 'react';
import { useMutation } from 'react-query';
import ConfirmationModal from 'v2/common/ConfirmationModal/ConfirmationModal';
import { DataProductRestriction } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { PostProcessKeys, TranslationKeys } from 'translations';
import { useTranslation } from 'react-i18next';

interface DeleteDataProductRestrictionModalProps {
  itemToRemove: DataProductRestriction;
  onClose: () => void;
  reloadRestrictions: () => Promise<void>;
}

const DeleteDataProductRestrictionModal = ({
  itemToRemove,
  onClose,
  reloadRestrictions,
}: DeleteDataProductRestrictionModalProps) => {
  const { t } = useTranslation();
  const { mutate: deleteRestriction, isLoading: isDeleting } = useMutation(
    async () => {
      await restFactory.delete(`/dj/api/v1/restrictions/${itemToRemove.id}/`);
    },
    {
      onSuccess: async () => {
        await reloadRestrictions();
        toast.success('Restriction deleted successfully.');
      },
      onError: (error: AxiosError | string) => {
        const errorMessage =
          typeof error === 'string'
            ? error
            : 'An error occurred while deleting the Restriction. Please contact support.';
        toast.error(errorMessage);
      },
      onSettled: () => {
        onClose();
      },
    }
  );

  const deleteItem = async () => {
    deleteRestriction();
  };

  return (
    <ConfirmationModal
      show={true}
      onCancel={onClose}
      onOk={deleteItem}
      okBtnText="Delete"
      isLoading={isDeleting}
      title={`Delete ${t(TranslationKeys.dataProduct_one, {
        postProcess: PostProcessKeys.TitleCase,
      })} Restriction`}
    >
      <>Are you sure you want to delete this restriction?</>
    </ConfirmationModal>
  );
};

export default DeleteDataProductRestrictionModal;
